// extracted by mini-css-extract-plugin
module.exports = {"table_flame":"RefundsDetail_table_flame_30oUq","refundBtn":"RefundsDetail_refundBtn_1Iqrh"};